import { render, staticRenderFns } from "./Cts.vue?vue&type=template&id=52e0974c"
import script from "./Cts.vue?vue&type=script&lang=ts"
export * from "./Cts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports